import styled from 'styled-components'
import React from 'react'

interface ArrowProps {
  isHidden?: boolean;
}

export const LeftArrow = styled.svg.attrs({
  width: 15,
  height: 30,
  viewBox: '0 0 15 30',
  children: <path d="M11.785 27.607a1.333 1.333 0 01-2.236 1.453L.882 15.727a1.333 1.333 0 010-1.454L9.55.94a1.333 1.333 0 112.236 1.453L3.59 15l8.195 12.607z" fill="#2D263B"/>
})<ArrowProps>`
  z-index: 6;
  left: -20px;
  ${({ isHidden }) => isHidden ? `visibility: hidden;` : ''};
`

export const RightArrow = styled.svg.attrs({
  width: 12,
  height: 30,
  viewBox: '0 0 12 30',
  children: <path d="M.882 27.607L9.076 15 .882 2.393A1.333 1.333 0 013.118.94l8.667 13.333a1.333 1.333 0 010 1.454L3.118 29.06a1.333 1.333 0 01-2.236-1.453z" fill="#2D263B"/>
})<ArrowProps>`
  z-index: 6;
  right: -20px;
  ${({ isHidden }) => isHidden ? `visibility: hidden;` : ''};
`
